// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__0RL9E","btnLg":"Button_btnLg__0sP2W"};